import { useEffect, useState } from 'react'
import { useNVAlertsContext } from '@nv/contexts'
import styles from './NVAlertsBanner.module.scss'

const AlertItem = ({ alert, onHide }) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const slideIn = setTimeout(() => setIsVisible(true), 1)
    const slideOut = setTimeout(() => setIsVisible(false), 3500)
    const remove = setTimeout(() => onHide(alert.id), 4000)

    return () => {
      clearTimeout(slideIn)
      clearTimeout(slideOut)
      clearTimeout(remove)
    }
  }, [])

  return (
    <div className={[styles['container'], isVisible && styles['container--visible']].filter(Boolean).join(' ')} style={alert.style}>
      <div className={styles['extend-info']}>
        <div className={styles['content']}>
          {alert.icon} {alert.message}
        </div>
      </div>
    </div>
  )
}

export const NVAlertsBanner = () => {
  const { alerts, hideAlert, loading } = useNVAlertsContext()

  return (
    <>
      {loading && (
        <div className={styles['loader-track']}>
          <div className={styles['loader-bar']} />
        </div>
      )}
      <div className={styles['stack']}>
        {alerts.map((alert) => (
          <AlertItem key={alert.id} alert={alert} onHide={hideAlert} />
        ))}
      </div>
    </>
  )
}
